/**
 * Selects a unique image URL from observations that hasn't been used yet
 * @param observations - Array of observations containing resolvedMediaReferences
 * @param usedImages - Set of already used image URLs
 * @param mainImage - Optional main image to use as first priority
 * @returns First unused image URL, or first available image if all were used, or undefined
 */
export const selectUniqueImage = ({
  observations,
  usedImages,
  mainImage,
}: {
  observations?: Array<{
    resolvedMediaReferences: Array<{ reference: string; url: string | null }>;
  }>;
  usedImages: Set<string>;
  mainImage?: string;
  sectionName?: string;
}): string | undefined => {
  // Priority 1: Use mainImage if available
  if (mainImage) {
    return mainImage;
  }

  if (!observations || observations.length === 0) {
    return undefined;
  }

  // Priority 2: Try to find an unused image from observations
  for (const observation of observations) {
    for (const mediaRef of observation.resolvedMediaReferences) {
      if (mediaRef.url && !usedImages.has(mediaRef.url)) {
        return mediaRef.url;
      }
    }
  }

  // No unique images found, return undefined
  return undefined;
};
